import { useEffect, useState } from 'react'
import { useRouter } from 'next/router'
import { useDispatch } from 'react-redux'
import { periodState, loginTypeState } from '@/features/authSlice'

export const usePeriod = ({ campaign }: { campaign: Api.CampaignResBody }) => {
  const router = useRouter()
  const dispatch = useDispatch()
  const [PeriodState, setPeriodState] = useState(undefined)
  // キャンペーンが開催中: campaignIsOpen = true
  // 他のuseStateは信用に値しないので仮で新しいuseStateを使っている。
  // 今後、安全に削除できることを確認できたら、以下のstateだけにする
  // localStorage周りの修正もしたかったが、地味に色々なところで使われているので、一旦このままにしてある
  const [campaignIsOpen, setCampaignIsOpen] = useState<boolean>(false)
  const [loadingCampaignIsOpen, setLoadingCampaignIsOpen] = useState<boolean>(true)

  const handlePeriod = (campaign) => {
    if (campaign === 'notice') {
      localStorage.setItem(`${process.env.NEXT_PUBLIC_SERVICE_NAME}-period`, 'false')

      if (router.pathname == '/notice') {
        dispatch(periodState(true))
      } else {
        location.href = `${process.env.NEXT_PUBLIC_SITEURL}/${process.env.NEXT_PUBLIC_SERVICE_NAME}/notice`
      }

      return
    }

    if (campaign === false) {
      localStorage.setItem(`${process.env.NEXT_PUBLIC_SERVICE_NAME}-period`, 'false')
    }
  }

  useEffect(() => {
    if (campaign && campaign.campaignEndAt !== '') {
      setPeriodState(campaign)
    }
    if (campaign && campaign.campaignEndAt !== '') {
      const currentDate = new Date()
      const startDate = new Date(campaign.campaignStartAt)
      const endDate = new Date(campaign.campaignEndAt)
      if (startDate < currentDate && currentDate < endDate) {
        dispatch(periodState(true))
        setCampaignIsOpen(true)
      } else {
        dispatch(periodState(false))
        setCampaignIsOpen(false)
      }
      setLoadingCampaignIsOpen(false)
    }
  }, [campaign])

  useEffect(() => {
    if (PeriodState !== undefined) {
      dispatch(loginTypeState(PeriodState.loginType))

      if (PeriodState.period === false) {
        dispatch(periodState(false))
        handlePeriod(PeriodState.period)
        return
      }

      if (PeriodState.outOfTermMessage !== null) {
        localStorage.removeItem(`${process.env.NEXT_PUBLIC_SERVICE_NAME}-period`)

        dispatch(periodState(false))
        handlePeriod('notice')

        return
      }

      localStorage.removeItem(`${process.env.NEXT_PUBLIC_SERVICE_NAME}-period`)
      dispatch(periodState(true))

      return
    }
  }, [PeriodState])

  return { campaignIsOpen, loadingCampaignIsOpen }
}
